import { FC } from "react";
import { useFormContext } from "react-hook-form";
import {
  FormControllerCheckbox,
  MuiBox,
  MuiCheckbox,
  MuiGrid,
  MuiTypography,
} from "../../../../../../components";
import { PAGE_IDS } from "../../../../../../helpers/constants";
import { useSiteCore } from "../../../../../../hooks/useSiteCore";
import {
  CreateGenericAccountFormKey,
  FeaturesCheckBoxes,
} from "../../../modelsAndSchemas/Models";
import { createGenericAccounts } from "../../../siteCore/SiteCoreKeys";
import { CreateGenericAccountCheckboxWrapper } from "./CreateGenericAccountCheckbox.styles";

const pageId = PAGE_IDS.CREATE_GENERIC_ACCOUNT_CONFIG_FEATURES;

interface CreateGenericAccountCheckboxProps {
  fieldArray: FeaturesCheckBoxes[];
}

const gridSize = { lg: 4, md: 6, xs: 12, sm: 6 };

const groupBySection = (flatData: FeaturesCheckBoxes[]) => {
  return flatData.reduce(
    (acc: Record<string, FeaturesCheckBoxes[]>, item: FeaturesCheckBoxes) => {
      if (!acc[item.sectionTitle]) {
        acc[item.sectionTitle] = [];
      }
      acc[item.sectionTitle].push(item);
      return acc;
    },
    {},
  );
};

export const CreateGenericAccountCheckbox: FC<
  CreateGenericAccountCheckboxProps
> = ({ fieldArray }) => {
  const { control } = useFormContext();
  const { fetchComponentTitle } = useSiteCore();
  const groupedData = groupBySection(fieldArray);

  return (
    <CreateGenericAccountCheckboxWrapper>
      <MuiTypography variant="h2SemiBold" className="mainTitle">
        {fetchComponentTitle(
          createGenericAccounts.createGenericAccountFeaturesTitle,
        )}
      </MuiTypography>
      {Object.entries(groupedData).map(([sectionTitle, items], index) => (
        <MuiBox key={`${sectionTitle}-${index}`} className="section-container">
          <MuiTypography id="id-group-label" variant="h2SemiBold">
            {sectionTitle}
          </MuiTypography>
          <MuiBox role="group" aria-labelledby="id-group-label">
            <MuiGrid role="list" container className="checkbox-container">
              {items.map((checkboxItem: FeaturesCheckBoxes) => {
                const flatIndex = fieldArray.findIndex(
                  (f) => f.id === checkboxItem.id,
                );
                return (
                  <MuiGrid
                    size={gridSize}
                    key={checkboxItem.featuresUniqueId}
                    role="listitem"
                  >
                    <FormControllerCheckbox
                      control={control}
                      name={`${CreateGenericAccountFormKey.features}[${flatIndex}].isChecked`}
                    >
                      <MuiCheckbox
                        value={checkboxItem?.isChecked ?? false}
                        id={`${pageId}-${checkboxItem.id}`}
                        checkboxLabel={checkboxItem.name}
                      />
                    </FormControllerCheckbox>
                  </MuiGrid>
                );
              })}
            </MuiGrid>
          </MuiBox>
        </MuiBox>
      ))}
    </CreateGenericAccountCheckboxWrapper>
  );
};
